import { getCastImg, Permalink } from '../../helpers';
import { Role } from '../../typings/notGenerated';
import AppLink from '../AppLink/AppLink';
import BasePopup from './BasePopup';

interface Props {
  onClose: () => void;
  headline: string;
  roles: Role[];
}

function CastPopup({ onClose, headline, roles }: Props): JSX.Element {
  return (
    <BasePopup showCloseIcon={true} classes={['text-content', 'list-content']} onClose={onClose}>
      <h2>{headline}</h2>
      <ul className="wrapper">
        {roles.map((role) => (
          <li key={role.name}>
            <h3>{role.name}</h3>
            <ul>
              {role.celebrities.map((cel) => {
                return (
                  <li key={cel.id}>
                    <AppLink href={Permalink.celebrity(cel)}>
                      <a>
                        {getCastImg(cel)}
                        {cel.name}
                      </a>
                    </AppLink>
                  </li>
                );
              })}
            </ul>
          </li>
        ))}
      </ul>
    </BasePopup>
  );
}

export default CastPopup;
